import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Pill } from '@lifeomic/chroma-react/components/Pill';

const messages = defineMessages({
  auditEventCount: {
    id: 'auditLog.auditEventCountPill.auditEventCount',
    defaultMessage:
      '{count}{count, plural, one { Result} =9999 {+ Results} other { Results}}',
  },
});

const useStyles = makeStyles(() => ({
  noWrap: {
    whiteSpace: 'nowrap',
  },
}));

interface AuditEventCountPillProps {
  count: number;
}

const AuditEventCountPill: React.FC<AuditEventCountPillProps> = ({ count }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  return (
    <Pill
      label={formatMessage(messages.auditEventCount, {
        count,
      })}
      className={classes.noWrap}
    />
  );
};

export default React.memo(AuditEventCountPill);
